export const state = {
  // product: undefined,
  // products: []
  temoin: {},
  temoins: [],
  pagination: {
    size: 10,
  },
};
